<template>
    <div class="guide-step">
        <div class="head clearfix">
            <div class="step-count" v-if="!step.hideCount">
                <span class="step-count-number" v-text="'0' + (index + 1)"></span>
            </div>
            <div class="right-content" v-bind:class="{'show-on-right': !step.hideCount}">
                <div class="step-top">
                    <div class="step-title" v-text="step.title" v-bind:class="{'m-t-10': !step.hideCount}" v-if="step.title"></div>
                    <ul class="step-description" v-bind:style="{'font-size': step.title ? '14px' : '16px'}">
                        <li v-for="(desc, index) in step.description" v-bind:key="index" v-text="desc" :class="{ 'attention': desc.indexOf('注：') > -1}"></li>
                    </ul>
                    <div class="step-tips" v-text="step.tips" v-if="step.tips"></div>
                </div>
                <div class="step-sub" v-for="(sub, subIndex) in step.sub" v-bind:key="subIndex">
                    <div class="step-sub-head" v-if="sub.title" v-text="sub.title"
                        v-bind:style="{'font-size': step.hideCount ? '18px' : '16px'}"></div>
                    <div class="step-sub-images">
                        <div class="step-image" v-bind:style="{'text-align': image.align ? image.align : 'center'}"
                            v-for="(image, index) in sub.images" v-bind:key="index">
                            <img v-bind:src="imageBaseUrl + image.name + imageSuffix" alt="tips"
                                v-bind:style="{'margin-left': image.align === 'left' ? '-5px' : '0'}"
                                v-bind:class="{'m-t-20': index === 0}">
                            <div class="step-sub-tips" v-if="image.tips" v-text="image.tips.content"
                                v-bind:style="{'left': image.tips.position.left + 'px', 'top': image.tips.position.top + 'px'}"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'GuideStep',
  props: ['step', 'index'],
  data() {
    return {
      imageBaseUrl: 'https://o.666visa.cn/static/common/guides/',
      imageSuffix: '.png',
    };
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/less/variable";

.guide-step {
  .head {
    overflow: hidden;
    .step-count {
      float: left;
      width: 57px;
      height: 40px;
      background-image: url("../../../assets/imgs/number.png");
      background-position: left center;
      background-repeat: no-repeat;
      text-align: center;
      color: #fff;
      font-size: 16px;
      position: relative;
      .step-count-number {
        position: absolute;
        left: 11px;
        top: 11px;
        color: #fff;
        font-size: 16px;
        line-height: 16px;
      }
    }
    .show-on-right {
      margin-left: 57px;
    }
    .right-content {
      .step-top {
        .m-t-10 {
          margin-top: 10px;
        }
        .step-title {
          color: #444;
          font-size: 18px;
          line-height: 18px;
          margin-bottom: 8px;
        }
        .step-description {
          font-size: 16px;
          line-height: 25px;
          color: #444;
          padding-top: 7px;
          li.attention {
            color: #ff5a60;
          }
        }
        .step-tips {
          color: #777;
          font-size: 14px;
          margin-top: 7px;
        }
      }
      .step-sub {
        .step-sub-head {
          color: @blue;
          font-size: 18px;
          border-bottom: 1px solid @blue;
          padding-bottom: 10px;
          padding-top: 30px;
        }
        .step-sub-images {
          .step-image {
            position: relative;
            .m-t-30 {
              margin-top: 30px;
            }
            .m-t-20 {
              margin-top: 20px;
            }
            img {
              display: inline-block;
              margin-bottom: 30px;
              max-width: 100%;
            }
            .step-sub-tips {
              position: absolute;
              font-size: 12px;
              color: #ff5a60;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/guide/component/GuideStep.vue